import { render, staticRenderFns } from "./Slice--Header.vue?vue&type=template&id=5882747e&lang=pug&"
import script from "./Slice--Header.vue?vue&type=script&lang=js&"
export * from "./Slice--Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports